module.exports = __webpack_public_path__ + "img/d_sv4.22a3b14.png";